var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientRecordsDesk',{attrs:{"userList":_vm.userList,"ClientList":_vm.ClientList},on:{"RESET":function($event){return _vm.$emit('RESET')},"SearchName":_vm.SearchName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }